import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { UserModel } from '../../models';
import { ApiListDataService } from './api.list-data.service';
import { catchError } from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class ApiUserService extends ApiListDataService<UserModel, UserModel> {
    public userInfo = (): Observable<UserModel> => {
        return this.get('UserInfo');
    };

    constructor(http: HttpClient) {
        super(http, '/User/');
    }

    public download(data: { [key: string]: string }): Observable<any> {
        const requestOptions: object = {
            responseType: 'blob',
            observe: 'response',
            params: data,
        };

        return this.http
            .get(`${this.fullUrl('')}/Export`, requestOptions)
            .pipe(catchError(this.formatErrors));
    }

    public changePassword(currentPassword: string, newPassword: string): Observable<unknown> {
        const params = new HttpParams()
            .set('currentPassword', currentPassword)
            .set('newPassword', newPassword);

        return this.get<unknown>('ChangePassword', params);
    }
}

@Injectable({
    providedIn: 'root',
})
export class ApiUserWithPasswordService extends ApiListDataService<UserModel, UserModel> {
    constructor(http: HttpClient) {
        super(http, '/User?withoutPassword=true');
    }
}

@Injectable({
    providedIn: 'root',
})
export class ApiUserWithOutPassword extends ApiListDataService<UserModel, UserModel> {
    constructor(http: HttpClient) {
        super(http, '/User');
    }
}
